<h3>Menu Items</h3>
<a (click)="createMenuItem()">
  <i class="material-icons text-success h2">add</i>
</a>
<div *ngFor="let menuItem of menuItems; let i = index;">
  <app-menu-link-display (changes)="this.onChanges($event)" [overrideCollapsed]="childOverrideCollapsed"
                         [menuItem]="menuItem" [index]="i"></app-menu-link-display>
</div>
